import axios from 'axios'

export default {
    getParts(term, serviceCompanyId) {
        return axios.get('/api/parts/lookup',
            {
                params: {
                    term: term,
                    serviceCompanyId: serviceCompanyId,
                    unavailableForPartsOrders: true
                }
            });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/shared/components/partselector/api.js